export default __webpack_public_path__ + "static/media/gettingSwarm.af67d757.JPG";